<template>
  <div class="reports__panel--group">
    <div class="region-override">
      <b-field label="Gruppe" class="group">
        <dropdown :sourceList="filteredGroups"
                  :keyPropertyName="(o) => o.id"
                  :displayPropertyName="(o) => o.title"
                  :selectedValue="group"
                  @selectionChanged="(group) => { this.group = group; this.$emit('groupId', group);}">
        </dropdown>        
      </b-field>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import APISTATE from '@/enums/APISTATE';
import Dropdown from '@/components/common/Dropdown.vue';

export default {
  name: 'reports-panel-group',
  components: { Dropdown },
  props: {
    addDefault: {
      type: Boolean,
      default: false
    },
    value: {
      type: String
    }
  },
  data: () => ({
    group: undefined,
  }),
  async mounted() {
    await this.getAllGroups();
  },
  methods: {
    ...mapActions('groupStore', ['getAllGroups'])
  },
  computed: {
    ...mapGetters('groupStore', ['groupApiState', 'groups']),
    loading() {
      return this.groupApiState === APISTATE.LOADING;
    },
    filteredGroups(){
      if(this.groups && this.addDefault) {
        const result = [];
        result.push({ id: null, title: 'Alle'});
        
        this.groups.forEach(element => {
          result.push(element);
        });
        return result;
      }
      return this.groups;
    },
  },
  watch: {
    'value'(newValue){
      this.group = newValue
    }
  }

}
</script>

<style lang="scss">
.reports__panel--group {
  .ctrl-button {
    padding-left: 10px !important;
  }
}
</style>
